import {GetEmailPageComponent} from './GetEmailPage.component';

export const GetEmailPage = GetEmailPageComponent;
